import {cookie} from "../lib/cookie";
import {writable} from 'svelte/store';
import {USER_ROLE} from "../lib/constants";

let userObject = {
    id: null,
    name: null,
    username: null,
    role_id: 0,
    is_admin: 0,
    token: null,
};

const {get, set, update, subscribe} = writable(userObject);

const user = {
    set,
    update,
    subscribe,

    getToken: () => {
        return userObject.token || '';
    },

    acronym : () => {
        if (!userObject.name) {
            return '';
        }
        return userObject.name.split(' ').map(function(item){return item[0]}).join('');
    },

    initialize: () => {
        user.update(obj => {
            obj.token = cookie.get('hva-app') || null;
            return obj;
        });
    },

    setUser: data => {
        user.update(obj => {
            obj.id = data.id;
            obj.name = data.name;
            obj.username = data.username;
            obj.token = data.token;
            obj.role_id = data.role_id;
            obj.is_admin = data.is_admin;
            user.saveCookie();
            return obj;
        });
    },

    clearToken: () => {
        user.update(obj => {
            obj.token = null;
            user.saveCookie();
            return obj;
        });
    },

    saveCookie: () => {
        let coo = {
            token: userObject.token,
        };
        cookie.create('hva-app', userObject.token);
    },

    isAdmin: () => {
        // return userObject.is_admin == USER_ROLE.ADMIN;
        return userObject.role_id == USER_ROLE.ADMIN;
    }
}

export default user;